import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from './CatalogueRowActions';
import type { RequiredDocumentType } from './reference-data.api';

interface BuildRequiredDocumentTypeColumnsArgs {
  onEdit: (row: RequiredDocumentType) => void;
  onDeactivate: (row: RequiredDocumentType) => Promise<void>;
  onReactivate: (row: RequiredDocumentType) => Promise<void>;
}

export function buildRequiredDocumentTypeColumns({
  onEdit,
  onDeactivate,
  onReactivate,
}: BuildRequiredDocumentTypeColumnsArgs): TableColumnsType<RequiredDocumentType> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
